import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export const recaptchaUrl = "/api/v1/recaptcha";

export interface RecaptchaApiV1Parameter extends ApiParameter {
    token: string;
}

export async function verify(parameter: RecaptchaApiV1Parameter) {
    const recaptchaResult = await post<RecaptchaApiV1Parameter>(`${recaptchaUrl}/verify`, parameter);
    return recaptchaResult;
}
